
import Vue from "vue"
import { mapGetters } from "vuex"

export default Vue.extend({
  head () {
    return {
      title: this.getTitle(this.$t("pages.program.title")),
    }
  },

  computed: {
    ...mapGetters("app", ["getTitle"]),
  },
})
